<template lang="pug">
  FormModal(v-if="data", title="New Site", :endpoint="`partners/${partner_id}/sites`", :data="data", v-bind="$attrs", @success="success")
    InputGroup(label="Main Domain", name="domain")
      TextInput(v-model="data.domain")

    InputGroup(label="Allowed Domains", name="copilot_domains", description="Press 'enter' after each domain. Main domain is included automatically.")
      TagsInput(v-model="data.copilot_domains", prepend-icon="browser", placeholder="Enter domain...")

    InputGroup(label="Image", name="featured_image")
      FileInput(v-model="data.featured_image")

    InputGroup(label="Copilot CSS", name="copilot_css")
      TextInput(v-model="data.copilot_css", textarea)

    InputGroup(label="Disclaimer Enabled", name="copilot_disclaimer_enabled")
      ToggleSwitch(v-model="data.copilot_disclaimer_enabled", label="Enable disclaimer")

    InputGroup(v-show="data.copilot_disclaimer_enabled", label="Disclaimer", name="copilot_disclaimer_text", description="Leave blank to use default disclaimer.")
      TextInput(v-model="data.copilot_disclaimer_text", textarea)

    InputGroup(v-show="data.copilot_disclaimer_enabled", label="Disclaimer Selector - optional", name="copilot_disclaimer_selector", description="The disclaimer will be inserted after this selector. If left blank, the disclaimer will be inserted after the body tag.")
      TextInput(v-model="data.copilot_disclaimer_selector")

    InputGroup(label="Primary Site", name="primary")
      ToggleSwitch(v-model="data.primary", label="Set as primary site")

    InputGroup(label="Script Translations", name="translations_enabled")
      Radios(v-model="data.translations_enabled")
        Radio(:value="'none'")
          div.flex.flex-col
            span No translations will be loaded / debug mode.
            small.text-green-500 Minimal performance impact.
        Radio(:value="'partner'")
          div.flex.flex-col
            span Only the partner site's custom translations will be used.
            small.text-primary Minimal performance impact.
        Radio(:value="'selected'")
          div.flex.flex-col
            span Only the selected languages/translations will be used.
            small.text-orange-500 Medium performance impact.
        Radio(:value="'all'")
          div.flex.flex-col
            span All available languages/translations will be used.
            small.text-red-500 Maximum performance impact.

    InputGroup(label="Enabled Translations", name="enabled_translation_ids", v-if="data.translations_enabled === 'selected'")
      div.space-y-2
        div(v-for="translationLocale in translationLocales" :key="translationLocale.id")
          Checkbox(v-model="data.enabled_translation_ids" :value="translationLocale.id") {{ translationLocale.name }}
</template>

<script>
export default {
  props: {
    partner_id: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    data: {
      domain: null,
      copilot_domains: [],
      featured_image: null,
      copilot_css: null,
      copilot_disclaimer_enabled: false,
      copilot_disclaimer_text: null,
      copilot_disclaimer_selector: null,
      primary: false,
      translations_enabled: null,
      enabled_translation_ids: []
    },
    translationLocales: []
  }),
  async mounted() {
    let translationLocalesResponse = await this.$api.get("options/translation-locales")
    this.translationLocales = translationLocalesResponse.data?.items || []
  },
  methods: {
    success(result) {
      this.$notification.success(`Site **${this.data.domain}** successfully created.`)
      this.$emit("close", result)
    }
  }
}
</script>
